import './App.css';
import React, { useState } from 'react';
import PublicRoutes from './routes/publicRoutes'
import { ToastContainer } from 'react-toastify';
const App = () => {

  return (
    <div>
      <ToastContainer />
      <PublicRoutes />
    </div>
  );
};
export default App

